<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { callerMessageLink } from 'dashboard/api/relayVoiceInbound';
import BaseBubble from 'next/message/bubbles/Base.vue';
import RecordingPlayer from 'dashboard/components-next/call/RecordingPlayer.vue';
import FormattedContent from './Text/FormattedContent.vue';
import { useMessageContext } from '../provider.js';

// A message a caller left with Relay Voice: the transcript Relay wrote into
// the conversation, and a player for the audio, which stays on the voice
// host and plays only through a short-lived link for people who can open
// this conversation.
const { content, contentAttributes } = useMessageContext();
const { t } = useI18n();
const { accountId } = useAccount();

const voicemail = computed(() => contentAttributes.value?.relayVoiceMessage);
const fetchLink = download =>
  callerMessageLink(accountId.value, voicemail.value.callId, download);
</script>

<template>
  <BaseBubble class="px-4 py-3" data-bubble-name="voicemail">
    <div class="flex flex-col gap-3 min-w-64">
      <RecordingPlayer
        :fetch-link="fetchLink"
        :label="
          t(
            `RELAY_VOICE.RECORDING.MESSAGE_${(voicemail.kind || 'missed').toUpperCase()}`
          )
        "
      />
      <FormattedContent v-if="content" :content="content" />
    </div>
  </BaseBubble>
</template>
